import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const latencyApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://monitor.latency.thmcell.click/api',
  }),
  reducerPath: 'latencyApi',
  endpoints: (builder) => ({
    getClosestRegion: builder.query<string, void>({
      query: () => ({
        url: 'region',
        method: 'GET',
      }),
      transformResponse: (response: { region: string }) => response.region,
    }),
  }),
});

export const { useGetClosestRegionQuery } = latencyApi;
